module.exports = __webpack_public_path__ + "static/media/mediapartners.a34719c6.png";